"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetting = useSetting;
exports.useSettings = useSettings;
exports.useSetSetting = useSetSetting;
const usehooks_1 = require("@uidotdev/usehooks");
const defaultSettings = {
    showPing: false,
};
function useSetting(key) {
    const [settings] = (0, usehooks_1.useLocalStorage)("settings", defaultSettings);
    return settings[key];
}
function useSettings() {
    const [settings] = (0, usehooks_1.useLocalStorage)("settings", defaultSettings);
    return settings;
}
function useSetSetting(key) {
    const [, setSettings] = (0, usehooks_1.useLocalStorage)("settings", defaultSettings);
    return (value) => {
        setSettings((prev) => (Object.assign(Object.assign({}, prev), { [key]: value })));
    };
}
